<!-- components/AppBreadcrumb.vue -->
<script setup>
  import { ref, watch } from 'vue';
  import { useRoute } from 'vue-router';
  import { useMenuStore } from '@/stores/menu';

  const route = useRoute();
  const menuStore = useMenuStore();
  const items = ref([]);

  watch(
    () => route.path,
    (newPath) => {
      // 현재 경로에 따라 breadcrumb 아이템 생성
      const pathItems = menuStore.findMenuPath(newPath);
      items.value = pathItems.map((item) => ({
        label: item.label,
        to: item.to,
      }));
    },
    { immediate: true },
  );
</script>

<template>
  <div
    class="breadcrumb-container"
    v-if="items.length > 0"
  >
    <Breadcrumb
      :model="items"
      :home="{ icon: 'pi pi-home', to: '/' }"
    />
  </div>
</template>

<style lang="scss">
  /* scoped 제거하고 더 구체적인 선택자 사용 */
  .breadcrumb-container {
    width: 100%;
    padding: 0.1rem 2rem;
    background-color: transparent;
    //border-bottom: 1px solid var(--surface-border);
    position: relative;

    .p-breadcrumb.p-component {
      background-color: transparent !important;
      border: none;
      padding: 0.25rem;

      .p-breadcrumb-list {
        margin: 0;
        padding: 0;
        background-color: transparent !important;
      }

      .p-element {
        background-color: transparent !important;
      }

      .p-breadcrumb-chevron {
        background-color: transparent !important;
      }

      .p-menuitem {
        background-color: transparent !important;

        .p-menuitem-link {
          background-color: transparent !important;
          padding: 0.25rem 0.5rem;

          &:hover {
            background-color: transparent !important;
          }

          .p-menuitem-text {
            color: var(--text-color);
          }

          .p-menuitem-icon {
            color: var(--text-color);
          }
        }
      }
    }
  }
</style>
